import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
export default {
  name: "gifts",
  computed: {
    ...userVuex.mapState(["isLogin", "rewards", "userInfo", "settingInfo"])
  },
  data() {
    const menuBtns = {
      botcode: {
        title: "BotCode",
        page: "/botcode",
        reward: null
      },
      task: {
        title: "Task",
        page: "/rewards?tab=2",
        reward: null
      },
      turn: {
        title: "Lucky Wheel",
        page: "/turn",
        reward: null
      }
    };
    return {
      giftList: null,
      popGiftDetailShow: false,
      rowGift: null,
      popGiftSellShow: false,
      giftSellContent: null,
      rowGiftSellContent: null,
      myGiftList: null,
      myGiftListPage: {
        page: 1,
        limit: 50,
        isLoading: false,
        totalPages: 1
      },
      popMyGiftShow: false,
      menuBtns,
      adminName: "MemesGlo",
      isGiftSellLoading: false,
      isPopGiftSellClose: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.initFnc();
          this.setGiftSellContentText();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getBalanceInfo"]),
    setGiftSellContentText() {
      const giftSellContent = {
        get: {
          title: `Are you sure you want to <br> receive this gift`,
          content: `You won't be able to exchange it <br> for Telegram stars afterwards`,
          btn: `Get`,
          type: `get`,
          btnSkip: type => {
            this.giftSellBtnSkip(type);
          }
        },
        sell: {
          title: `Are you sure you want to sell it?`,
          content: `will be credited to your balance`,
          btn: `Submit`,
          type: `sell`,
          btnSkip: type => {
            this.giftSellBtnSkip(type);
          }
        },
        get2: {
          0: {
            //电报NFT
            title: `🎁 You’ve won a Gift!<br> Here’s how to get it`,
            content: `
          <p>1.Send a message to <i>@${this.settingInfo.botname}</i> with any content, such as hi, hello, etc.</p>
          <p>2.Your Gift will be delivered within 48 hours after your message — don’t miss it!  </p>
          <p>3.Gift status available in My Gifts. </p>
          `,
            type: "get2",
            btn: `Send a message to <br> our gift admin @${this.settingInfo.botname}`,
            btnSkip: () => {
              this.isPopGiftSellClose = true;
              _v.WebApp.openTelegramLink(`https://t.me/${this.settingInfo.botname}`);
            }
          },
          1: {
            //电报原生礼品
            title: `🎁 You’ve won a Gift!<br> Here’s how to get it`,
            content: `
          <p>1.Send a message to <i>@${this.adminName}</i> with any content, such as hi, hello, etc.</p>
          <p>2.Your Gift will be delivered within 48 hours after your message — don’t miss it! </p>
          <p>3.Gift status available in My Gifts. </p>
          `,
            type: "get2",
            btn: `Send a message to <br> our gift admin @${this.adminName}`,
            btnSkip: () => {
              this.isPopGiftSellClose = true;
              _v.WebApp.openTelegramLink(`https://t.me/${this.adminName.charAt(0).toLowerCase() + this.adminName.slice(1)}`);
            }
          }
        }
      };
      this.giftSellContent = giftSellContent;
    },
    onSkip(name) {
      _v.WebApp.openTelegramLink(`https://t.me/${name}`);
    },
    async initFnc() {
      await this.getGiftShardList();
    },
    async getGiftShardList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/shard/list", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          // this.giftList = data.sort((a, b) => b.shard_amount - a.shard_amount);
          this.giftList = data.map(item => {
            return {
              ...item,
              isGetLoading: false,
              isSellLoading: false
            };
          }).sort((a, b) => b.shard_amount - a.shard_amount);
          resolve(this.giftList);
        }, () => {
          resolve();
        });
      });
    },
    claimGift(type) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/claim", {
          giftId: this.rowGift.id,
          type
        });
        vailcode(res, async () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.giftList = data.gifts.map(item => {
            return {
              ...item,
              isGetLoading: false,
              isSellLoading: false
            };
          }).sort((a, b) => b.shard_amount - a.shard_amount);
          const items = this.giftList.filter(it => {
            return it.id == this.rowGift.id;
          });
          if (items && items.length > 0) {
            const itms = items[0];
            // let progress = [];
            // if (itms.shard_amount < itms.required_shards) {
            //   progress = [itms.shard_amount];
            // } else if (itms.shard_amount > itms.required_shards) {
            //   progress = [itms.required_shards, itms.shard_amount - parseInt(itms.shard_amount / itms.required_shards) * itms.required_shards];
            // }

            let progress = [itms.shard_amount];
            this.rowGift = {
              ...itms,
              progress,
              time: parseInt(itms.shard_amount / itms.required_shards),
              index: this.rowGift.index
            };
          }
          resolve(this.giftList);
        }, () => {
          resolve();
        });
      });
    },
    async onShowMyGift() {
      this.popMyGiftShow = true;
      this.myGiftAddEventListenerScroll();
    },
    async onOpenMarket() {
      this.WebApp.openLink("https://getgems.io/top-gifts");
    },
    onShowGiftDetail(item, index) {
      // let progress = [];
      // if (item.shard_amount < item.required_shards) {
      //   progress = [item.shard_amount];
      // } else if (item.shard_amount > item.required_shards) {
      //   progress = [item.required_shards, item.shard_amount - parseInt(item.shard_amount / item.required_shards) * item.required_shards];
      // }
      let progress = [item.shard_amount];
      this.rowGift = {
        ...item,
        progress,
        time: parseInt(item.shard_amount / item.required_shards),
        index
      };
      this.popGiftDetailShow = true;
    },
    setGiftSellContent(item, type) {
      if (type == 0) {
        this.rowGiftSellContent = this.giftSellContent["get"];
      } else {
        const sell = this.giftSellContent["sell"];
        sell.content = `${this.rowGift.recycling_stars} <img src="${require("@images/icon/icon-star.png")}" alt="" /> will be credited to your balance`;
        this.rowGiftSellContent = sell;
      }
    },
    onShowGiftSell(item, type) {
      this.setGiftSellContent(item, type);
      this.popGiftSellShow = true;
    },
    async giftSellBtnSkip(type) {
      if (type == "get" && this.rowGift.gift_type == 0) {
        if (this.giftList[this.rowGift.index].isGetLoading) return;
        this.giftList[this.rowGift.index].isGetLoading = true;
        const res = await this.claimGift(0);
        if (!res) {
          this.giftList[this.rowGift.index].isGetLoading = false;
          return;
        }
        this.rowGiftSellContent = this.giftSellContent["get2"][0];
      } else if (type == "get" && this.rowGift.gift_type == 1) {
        if (this.giftList[this.rowGift.index].isGetLoading) return;
        this.giftList[this.rowGift.index].isGetLoading = true;
        const res = await this.claimGift(0);
        if (!res) {
          this.giftList[this.rowGift.index].isGetLoading = false;
          return;
        }
        this.rowGiftSellContent = this.giftSellContent["get2"][1];
      } else if (type == "sell") {
        if (this.giftList[this.rowGift.index].isSellLoading) return;
        this.giftList[this.rowGift.index].isSellLoading = true;
        const res = await this.claimGift(1);
        if (!res) {
          this.giftList[this.rowGift.index].isSellLoading = false;
          return;
        }
        await this.getBalanceInfo(false);
        this.$toasted.success("Sold successfully");
        this.popGiftSellShow = false;
      }
    },
    getMyGiftList(page = 1, limit = 10) {
      this.myGiftListPage.isLoading = true;
      // 模拟后端总数据
      // const allItems = Array.from({ length: 35 }, (_, i) => ({
      //   id: i + 1,
      //   gift_id: 5,
      //   gift_type: 0,
      //   gift_name: "",
      //   gift_thumb: "https://tstatic.humanpass.net/202507/25/3d490fc3-ac70-4b1e-ad23-ed0c14ebc3f6.png",
      //   gift_image: "https://tstatic.humanpass.net/202507/25/b08ad29b-02f7-4e23-95d4-815cc37c9954.png",
      //   gift_stars: 25,
      //   gift_status: 0,
      //   recycling_stars: 0,
      //   status: 0,
      //   created_at: new Date().toISOString(),
      // }));

      // const total = allItems.length;
      // const start = (page - 1) * limit;
      // const end = page * limit;
      // const paginatedItems = allItems.slice(start, end);

      // const res = {
      //   code: 0,
      //   message: "",
      //   data: {
      //     total,
      //     perPage: limit,
      //     lastPage: Math.ceil(total / limit),
      //     currentPage: page,
      //     items: paginatedItems,
      //   },
      // };
      return new Promise(async resolve => {
        const res = await _v.$http.post("/gift/my/list", {
          page,
          limit
        });
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.myGiftList = items;
          } else {
            this.myGiftList.push(...items);
          }
          this.myGiftListPage.totalPages = res.data.lastPage;
          this.myGiftListPage.page = page;
          this.myGiftListPage.isLoading = false;
          resolve(items);
        }, () => {
          this.myGiftListPage.isLoading = false;
          resolve([]);
        });
      });
    },
    async myGiftHandleScroll(e) {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !this.myGiftListPage.isLoading && this.myGiftListPage.page < this.myGiftListPage.totalPages) {
        this.getMyGiftList(this.myGiftListPage.page + 1, this.myGiftListPage.limit);
      }
    },
    myGiftAddEventListenerScroll() {
      this.$nextTick(() => {
        const container = this.$refs.popmygift;
        console.log(this.$el, "container", container);
        setTimeout(() => {
          this.getMyGiftList(1, this.myGiftListPage.limit);
          if (container) {
            container.onscroll = this.myGiftHandleScroll;
          }
        }, 200);
      });
    }
  },
  mounted() {
    this.setWowAnim();
  }
};